export default "__VITE_ASSET__CEaDnnTj__"